'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on('click', '[data-watchdog]', function () {
    var $this = (0, _jquery2.default)(this);
    var productId = parseInt($this.attr('data-watchdog'), 10);
    var isActive = $this.is('.active');

    if (isActive) {
        // remove item
        abp.services.api.wishlist.removeItem(productId).done(function () {
            $this.removeClass('active');

            $this.find('i').removeClass('animated tada');
        });
    } else {
        // add item
        abp.services.api.wishlist.addItem(productId).done(function (result) {
            abp.log.info('wishlist item add ' + productId);
            abp.log.debug(result);
            if (result) {
                $this.addClass('active');

                $this.find('i').addClass('animated tada');
                abp.log.debug('wishlist item ' + productId + ' successfully added.');
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/watchdog.js
// module id = 968
// module chunks = 0